import { lazy, Suspense, useEffect } from 'react'

import { type IA2uiSurfaceProps } from '../A2uiSurface'

const A2uiSurfaceUnavailable = ({ onFailed }: IA2uiSurfaceProps) => {
  useEffect(() => {
    onFailed?.()
  }, [onFailed])
  return null
}

const A2uiSurface = lazy(() =>
  import('../A2uiSurface')
    .then(({ A2uiSurface: Surface }) => ({ default: Surface }))
    .catch(() => ({ default: A2uiSurfaceUnavailable }))
)

export const LazyA2uiSurface = (props: IA2uiSurfaceProps) => (
  <Suspense fallback={null}>
    <A2uiSurface {...props} />
  </Suspense>
)
